import { render, staticRenderFns } from "./PrivateLayout.vue?vue&type=template&id=6a909b76&scoped=true&"
import script from "./PrivateLayout.vue?vue&type=script&lang=js&"
export * from "./PrivateLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a909b76",
  null
  
)

export default component.exports